module.exports = __webpack_public_path__ + "static/media/qingdao.f2a0dab0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/qingdao.png
 ** module id = 469
 ** module chunks = 0
 **/